import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {Button, Typography, Paper, Box} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import router from "../../routePaths/routePaths";

export default function MonthlyPermit() {
    let navigate = useNavigate();
    const {domain} = useParams();

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <div classNmae="row">
                                <Typography>
                                    Please select Permit Type
                                </Typography>
                            </div>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.new_monthly_permit+'/'+domain)}>
                                    Add a new Monthly Permit
                                </Button>
                                <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.update_monthly_permit+'/'+domain)}>
                                    Update Monthy Permit
                                </Button>
                                <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.external_permit+'/'+domain)}>
                                    Add External Permit
                                </Button>
                            </Box>
                            <div className="row">
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
        </div>
    );
}
